import React, {forwardRef} from 'react'
import PropTypes from 'prop-types'

const Video = forwardRef(({src, preload = 'metadata', ...props}, ref) => {
    return (
        <video 
            autoPlay 
            muted 
            loop 
            width="100%" 
            height="auto" 
            playsInline 
            preload={preload}
            {...props}
            ref={ref}
        >
            <source src={src} type="video/mp4" />
        </video>
    )
})

Video.propTypes = {
    src: PropTypes.string,
    preload: PropTypes.oneOf(['none', 'metadata', 'auto']),
    ref: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({
            current: PropTypes.any
        })
    ])
}

Video.displayName = 'Video'

export default Video
